export default __webpack_public_path__ + "assets/images/error.0ce074.avif";